var _path, _path2, _path3, _path4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 60C30.0589 60 22 51.9411 22 42C22 32.0589 30.0589 24 40 24C49.9411 24 58 32.0589 58 42C58 51.9411 49.9411 60 40 60Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1477 36.3636H36.7273L40.1818 44.7955H40.3182L43.7727 36.3636H46.3523V48H44.3295V40.0057H44.2216L41.0057 47.9659H39.4943L36.2784 39.9886H36.1705V48H34.1477V36.3636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2627 28.7383L1.5422 1.48375",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0742 28.8555L78.7813 2",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 23,
    x2: 40,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/motor.939c5acd4713c3c395591ef323f577f1.svg";
export { ForwardRef as ReactComponent };